import React, {useEffect, useState} from 'react';
import styles from './index.module.scss'
import Footer from '../../components/footer'
import NavbarMenus from '../../components/navbarMenus'
import PrismCode from '../../components/PrismCode'
import { MenuFoldOutlined } from '@ant-design/icons';
import Header from "../../components/header";

const installCode = `ohpm install @mcui/mccharts`

const introduceCode = `
 import { McLineChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
    @State maxData: number[] = [11, 11, 15, 13, 12, 130, 10]
    @State minData: number[] = [1, -20, 2, 5, 3, 2, 0]
    // 初始化数据
    @State seriesOption: Options = new Options({
      xAxis:{
        data:['周一','周二','周三','周四','周五','周六','周日']
      },
      yAxis:{
        name:'温度'
      },
      series:[
        {
          name:'最高气温',
          data: this.maxData
        },
        {
          name:'最低气温',
          data: this.minData
        }
      ]
    })
    // 动态修改数据
    aboutToAppear() {
        setTimeout(() => {
          // 传递需要修改的属性与数值，不需要全部传
          this.maxData = [110, 110, 150, 130, 120, 190, 100]
          this.minData = [-1, -2, -2, -5, 3, -2, 0]
          this.seriesOption.setVal({
            series:[
                {
                  name:'最高气温',
                  data: this.maxData
                },
                {
                  name:'最低气温',
                  data: this.minData
                }
            ]
          })
        }, 2000)
    }
    build() {
        Row() {
          McLineChart({
            options: this.seriesOption
          })
        }
        .height('50%')
    }
}
`

const GettingStarted = () => {
    return (
        <div className={styles.modules}>
            <div className={styles.navbar} id='nav'>
                <NavbarMenus path="GettingStarted"></NavbarMenus>
            </div>
            <div className={styles.view} id='chartView'>
                <Header title='入门'></Header>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>安装
                    </div>
                    <p>
                        - McCharts 是一个基于 ArkTS 语法封装的图表组件，你可以运行在ArkTS 12+版本以上的任意版本当中。
                    </p>
                    <PrismCode code={installCode} language="shell" plugins={['line-numbers']} />
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>引入组件与更新数据
                    </div>
                    <p>
                        - 引入对应的组件以及Options实体类
                    </p>
                    <p>
                        - 使用Options实体类初始化组件数据，返回实例对象
                    </p>
                    <p>
                        - 可以通过实例对象的更新数据方法实现动态更新组件内容
                    </p>
                    <p>
                        - 请看以下例子：
                    </p>
                    <PrismCode code={introduceCode} language="js" plugins={['line-numbers']} />
                </div>
                <Footer></Footer>
            </div>
        </div>
    )
}

export default GettingStarted
